export default __webpack_public_path__ + "src/download/Arquivo_Guia_Importacao_Beneficiarios.txt";